var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5V5.5H16V5C16 3.61929 14.8807 2.5 13.5 2.5C12.1193 2.5 11 3.61929 11 5ZM9 5.5V5C9 2.51472 11.0147 0.5 13.5 0.5C15.9853 0.5 18 2.51472 18 5V5.5H25.5C26.0523 5.5 26.5 5.94772 26.5 6.5C26.5 7.05228 26.0523 7.5 25.5 7.5H23.9922L22.0988 24.0677C21.8102 26.5931 19.6729 28.5 17.1311 28.5H9.8689C7.32714 28.5 5.18984 26.5931 4.90123 24.0677L3.00778 7.5H1.5C0.947715 7.5 0.5 7.05228 0.5 6.5C0.5 5.94772 0.947715 5.5 1.5 5.5H9ZM6.8883 23.8406C7.06146 25.3558 8.34384 26.5 9.8689 26.5H17.1311C18.6562 26.5 19.9385 25.3558 20.1117 23.8406L21.9792 7.5H5.0208L6.8883 23.8406ZM10.5 11C11.0523 11 11.5 11.4477 11.5 12V22C11.5 22.5523 11.0523 23 10.5 23C9.94771 23 9.5 22.5523 9.5 22V12C9.5 11.4477 9.94771 11 10.5 11ZM17.5 12C17.5 11.4477 17.0523 11 16.5 11C15.9477 11 15.5 11.4477 15.5 12V22C15.5 22.5523 15.9477 23 16.5 23C17.0523 23 17.5 22.5523 17.5 22V12Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearAll);
export default __webpack_public_path__ + "static/media/clear-all.aa55fbd8138f95157ac55b0325cdccc4.svg";
export { ForwardRef as ReactComponent };